export enum ActionTypes {
  LOAD_ETA_VEHICLES_REQUEST = 'LOAD_ETA_VEHICLES_REQUEST',
  LOAD_ETA_VEHICLES_SUCCEEDED = 'LOAD_ETA_VEHICLES_SUCCEEDED',
  LOAD_ETA_VEHICLES_FAILED = 'LOAD_ETA_VEHICLES_FAILED',

  LOAD_ETA_ROUTE_REQUEST = 'LOAD_ETA_ROUTE_REQUEST',
  LOAD_ETA_ROUTE_SUCCEEDED = 'LOAD_ETA_ROUTE_SUCCEEDED',
  LOAD_ETA_ROUTE_FAILED = 'LOAD_ETA_ROUTE_FAILED',
  CLEAR_ETA_ROUTE = 'CLEAR_ETA_ROUTE',

  OPEN_ETA_DIALOG = 'OPEN_ETA_DIALOG',
  CLOSE_ETA_DIALOG = 'CLOSE_ETA_DIALOG',

  APPLY_VEHICLE_GROUPS_FILTER_REQUEST = 'APPLY_VEHICLE_GROUPS_FILTER_REQUEST',
  APPLY_VEHICLE_FILTER_REQUEST = 'APPLY_VEHICLE_FILTER_REQUEST',
  APPLY_FILTERS_SUCCEEDED = 'APPLY_FILTERS_SUCCEEDED',
  APPLY_FILTERS_FAILED = 'APPLY_FILTERS_FAILED',
}
